'use strict'

var isInteger = require('is-integer')

module.exports = function isValidMonth (month) {
  if (typeof month !== 'number' || !isInteger(month)) return false
  return month >= 1 && month <= 12
}



//////////////////
// WEBPACK FOOTER
// ../~/is-valid-month/index.js
// module id = 1041
// module chunks = 0